import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getCloseoutContribs } from 'components/admin/projects/details/project-closeout/store/selectors';
import CloseoutContribForm from 'components/admin/projects/details/project-closeout/CloseoutContribForm';

class CloseoutContribForms extends Component {
  render() {
    const { closeoutContribs } = this.props;
    return closeoutContribs.map((closeoutContrib) => (
      <React.Fragment key={closeoutContrib.id}>
        <hr />
        <CloseoutContribForm closeoutContrib={closeoutContrib} />
      </React.Fragment>
    ));
  }
}

export default connect((state) => {
  return {
    closeoutContribs: getCloseoutContribs(state),
  };
})(CloseoutContribForms);



// WEBPACK FOOTER //
// ./src/components/admin/projects/details/project-closeout/CloseoutContribForms.js